import Row from "@/components/table/data/row";
import Cell from "@/components/table/data/cell";
import Column from "@/components/table/data/column";
import VueDataTable from "@/components/table/VueDataTable.vue";

const VUE_DATA_TABLE_NEED_DATA_UPDATE = "vue-data-table-need-data-update";

export { VUE_DATA_TABLE_NEED_DATA_UPDATE, Row, Cell, Column, VueDataTable as default };
